import React from 'react';
import {
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { asyncComponent } from '../utils/asyncComponent';
import VisitorMainLayout from '../views/MainLayout/VisitorMainLayout';

import { history } from '../store/createStore';

const Visitor = asyncComponent(() => import('../views/Visitor/Visitor'));

const mapStateToProps = (state) => ({
  menuData: state.root.menuData,
});

const routes = (props) => {
  return (
    <ConnectedRouter history={history} key={Math.random()}>
      <Switch>
        <VisitorMainLayout history={history} >
          <Switch>
            <Route component={Visitor} />
          </Switch>
        </VisitorMainLayout>
      </Switch>
    </ConnectedRouter>
  );
};

export default connect(mapStateToProps)(routes);



// WEBPACK FOOTER //
// ./src/routes/visitorRoute.js